<div class="admin-matrix-container" *ngIf="matrix">
  <table class="admin-matrix-table">
    <thead>
      <tr>
        <th class="permission-header">Permission</th>
        <th *ngFor="let role of getFilteredRoles()" 
            class="role-header" 
            [class.selected]="isRoleSelected(role)"
            [class.dimmed]="isRoleDimmed(role)"
            (click)="onRoleHeaderClick(role)">
          {{ formatRoleName(role.roleName) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let permission of getUniquePermissions()">
        <td class="permission-name">{{ permission }}</td>
        <td *ngFor="let role of getFilteredRoles()" 
            class="permission-cell"
            [class.selected]="isRoleSelected(role)"
            [class.dimmed]="isRoleDimmed(role)">
          <span class="permission-indicator" [class.has-permission]="hasPermission(role, permission)">
            <i class="fas fa-times" *ngIf="!hasPermission(role, permission)"></i>
            <i class="fas fa-check" *ngIf="hasPermission(role, permission)"></i>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="!matrix" class="loading">
  Loading admin matrix...
</div>
